/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiEntityType } from './InternalApiEntityType';
import {
    InternalApiEntityTypeFromJSON,
    InternalApiEntityTypeFromJSONTyped,
    InternalApiEntityTypeToJSON,
    InternalApiEntityTypeToJSONTyped,
} from './InternalApiEntityType';
import type { InternalApiUserBasicDetails } from './InternalApiUserBasicDetails';
import {
    InternalApiUserBasicDetailsFromJSON,
    InternalApiUserBasicDetailsFromJSONTyped,
    InternalApiUserBasicDetailsToJSON,
    InternalApiUserBasicDetailsToJSONTyped,
} from './InternalApiUserBasicDetails';

/**
 * 
 * @export
 * @interface InternalApiScreeningClearanceRulesAnalysisWithRunInfo
 */
export interface InternalApiScreeningClearanceRulesAnalysisWithRunInfo {
    /**
     * 
     * @type {number}
     * @memberof InternalApiScreeningClearanceRulesAnalysisWithRunInfo
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof InternalApiScreeningClearanceRulesAnalysisWithRunInfo
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiScreeningClearanceRulesAnalysisWithRunInfo
     */
    description?: string;
    /**
     * 
     * @type {InternalApiEntityType}
     * @memberof InternalApiScreeningClearanceRulesAnalysisWithRunInfo
     */
    entityType: InternalApiEntityType;
    /**
     * 
     * @type {InternalApiUserBasicDetails}
     * @memberof InternalApiScreeningClearanceRulesAnalysisWithRunInfo
     */
    createdBy?: InternalApiUserBasicDetails;
    /**
     * 
     * @type {Date}
     * @memberof InternalApiScreeningClearanceRulesAnalysisWithRunInfo
     */
    lastRunTime?: Date;
}



/**
 * Check if a given object implements the InternalApiScreeningClearanceRulesAnalysisWithRunInfo interface.
 */
export function instanceOfInternalApiScreeningClearanceRulesAnalysisWithRunInfo(value: object): value is InternalApiScreeningClearanceRulesAnalysisWithRunInfo {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('entityType' in value) || value['entityType'] === undefined) return false;
    return true;
}

export function InternalApiScreeningClearanceRulesAnalysisWithRunInfoFromJSON(json: any): InternalApiScreeningClearanceRulesAnalysisWithRunInfo {
    return InternalApiScreeningClearanceRulesAnalysisWithRunInfoFromJSONTyped(json, false);
}

export function InternalApiScreeningClearanceRulesAnalysisWithRunInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiScreeningClearanceRulesAnalysisWithRunInfo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'entityType': InternalApiEntityTypeFromJSON(json['entityType']),
        'createdBy': json['createdBy'] == null ? undefined : InternalApiUserBasicDetailsFromJSON(json['createdBy']),
        'lastRunTime': json['lastRunTime'] == null ? undefined : (new Date(json['lastRunTime'])),
    };
}

export function InternalApiScreeningClearanceRulesAnalysisWithRunInfoToJSON(json: any): InternalApiScreeningClearanceRulesAnalysisWithRunInfo {
    return InternalApiScreeningClearanceRulesAnalysisWithRunInfoToJSONTyped(json, false);
}

export function InternalApiScreeningClearanceRulesAnalysisWithRunInfoToJSONTyped(value?: InternalApiScreeningClearanceRulesAnalysisWithRunInfo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'description': value['description'],
        'entityType': InternalApiEntityTypeToJSON(value['entityType']),
        'createdBy': InternalApiUserBasicDetailsToJSON(value['createdBy']),
        'lastRunTime': value['lastRunTime'] == null ? value['lastRunTime'] : value['lastRunTime'].toISOString(),
    };
}

